import {Observable} from 'rxjs';
import {jobHunterAPI, RestQueryParams} from 'jobhunter-common-web';

export function checkOfferRecommendationAsSeenAPI(authToken: string | null, Id: string): Observable<any> {
    let headers = undefined;
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }

    return jobHunterAPI.put(`api/offer_recommendations/${Id}/seen`, {}, new RestQueryParams(), headers);
}
